import * as types from './actionTypes';

// ------- Fetch Contracts
export function fetchContractsV2() {
  return {
    type: types.FETCH_CONTRACTS_REQUEST
  };
}

export function fetchContractsV2Success({ data, offset }) {
  return {
    type: types.FETCH_CONTRACTS_SUCCESS,
    data,
    offset
  };
}

export function fetchContractsV2Fail({ error }) {
  return {
    type: types.FETCH_CONTRACTS_FAIL,
    error
  };
}

// ------- Fetch Contract
export function fetchContract({ contractNumber }) {
  return {
    type: types.FETCH_CONTRACT_REQUEST,
    contractNumber
  };
}

export function fetchContractSuccess({ data, contractNumber }) {
  return {
    type: types.FETCH_CONTRACT_SUCCESS,
    data,
    contractNumber
  };
}

export function fetchContractFail({ error, contractNumber }) {
  return {
    type: types.FETCH_CONTRACT_FAIL,
    error,
    contractNumber
  };
}

// ------- Fetch Contract
export function fetchQuote({ quoteNumber }) {
  return {
    type: types.FETCH_QUOTE_REQUEST,
    quoteNumber
  };
}

export function fetchQuoteSuccess({ data, quoteNumber }) {
  return {
    type: types.FETCH_QUOTE_SUCCESS,
    data,
    quoteNumber
  };
}

export function fetchQuoteFail({ error, quoteNumber }) {
  return {
    type: types.FETCH_QUOTE_FAIL,
    error,
    quoteNumber
  };
}

// ------- load more Parties
export function loadMoreContracts({ offset }) {
  return {
    type: types.LOAD_MORE_CONTRACTS_REQUEST,
    offset
  };
}

export function loadMoreContractsSuccess({ data, offset }) {
  return {
    type: types.LOAD_MORE_CONTRACTS_SUCCESS,
    data,
    offset
  };
}

export function loadMoreContractsFail({ error }) {
  return {
    type: types.LOAD_MORE_CONTRACTS_FAIL,
    error
  };
}

// ------- Fetch Contract Events
export function fetchContractEvents({ id }) {
  return {
    type: types.FETCH_CONTRACT_EVENTS_REQUEST,
    id
  };
}

export function fetchContractEventsSuccess({ data, id }) {
  return {
    type: types.FETCH_CONTRACT_EVENTS_SUCCESS,
    data,
    id
  };
}

export function fetchContractEventsFail({ error, id }) {
  return {
    type: types.FETCH_CONTRACT_EVENTS_FAIL,
    error,
    id
  };
}

// ------- Fetch Contract Documents
export function fetchContractDocuments({ id }) {
  return {
    type: types.FETCH_CONTRACT_DOCUMENTS_REQUEST,
    id
  };
}

export function fetchContractDocumentsSuccess({ data, id }) {
  return {
    type: types.FETCH_CONTRACT_DOCUMENTS_SUCCESS,
    data,
    id
  };
}

export function fetchContractDocumentsFail({ error, id }) {
  return {
    type: types.FETCH_CONTRACT_DOCUMENTS_FAIL,
    error,
    id
  };
}

// ------- Fetch ContractBeneficiaries
export function fetchContractBeneficiaries({ id, options }) {
  return {
    type: types.FETCH_CONTRACT_BENEFICIARIES_REQUEST,
    id,
    options
  };
}

export function fetchContractBeneficiariesSuccess({ data, id }) {
  return {
    type: types.FETCH_CONTRACT_BENEFICIARIES_SUCCESS,
    data,
    id
  };
}

export function fetchContractBeneficiariesFail({ error, id }) {
  return {
    type: types.FETCH_CONTRACT_BENEFICIARIES_FAIL,
    error,
    id
  };
}

// ------- Fetch ContractAttachments
export function fetchContractAttachments({ id }) {
  return {
    type: types.FETCH_CONTRACT_ATTACHMENTS_REQUEST,
    id
  };
}

export function fetchContractAttachmentsSuccess({ data, id }) {
  return {
    type: types.FETCH_CONTRACT_ATTACHMENTS_SUCCESS,
    data,
    id
  };
}

export function fetchContractAttachmentsFail({ error, id }) {
  return {
    type: types.FETCH_CONTRACT_ATTACHMENTS_FAIL,
    error,
    id
  };
}

// ------- Fetch ContractStatus
export function fetchContractStatus() {
  return {
    type: types.FETCH_CONTRACT_STATUS_REQUEST
  };
}

export function fetchContractStatusSuccess({ data }) {
  return {
    type: types.FETCH_CONTRACT_STATUS_SUCCESS,
    data
  };
}

export function fetchContractStatusFail({ error, id }) {
  return {
    type: types.FETCH_CONTRACT_STATUS_FAIL,
    error,
    id
  };
}

// ------- Add Contract Document
export function addContractDocument({ id, documentId, name, data }) {
  return {
    type: types.ADD_CONTRACT_DOCUMENT_REQUEST,
    id,
    documentId,
    name,
    data
  };
}

export function addContractDocumentSuccess({ id, documentId, document }) {
  return {
    type: types.ADD_CONTRACT_DOCUMENT_SUCCESS,
    documentId,
    id,
    document
  };
}

export function addContractDocumentFail({ error, id }) {
  return {
    type: types.ADD_CONTRACT_DOCUMENT_FAIL,
    error,
    id
  };
}

// ------- Add Contract Attachment
export function addContractAttachment({ id, name, data }) {
  return {
    type: types.ADD_CONTRACT_ATTACHMENT_REQUEST,
    id,
    name,
    data
  };
}

export function addContractAttachmentSuccess(data, id) {
  return {
    type: types.ADD_CONTRACT_ATTACHMENT_SUCCESS,
    data,
    id
  };
}

export function addContractAttachmentFail(error) {
  return {
    type: types.ADD_CONTRACT_ATTACHMENT_FAIL,
    error
  };
}

// ------- Delete Contract Document
export function deleteContractDocument({ id, documentId, attachmentId }) {
  return {
    type: types.DELETE_CONTRACT_DOCUMENT_REQUEST,
    id,
    documentId,
    attachmentId
  };
}

export function deleteContractDocumentSuccess(data, id) {
  return {
    type: types.DELETE_CONTRACT_DOCUMENT_SUCCESS,
    data,
    id
  };
}

export function deleteContractDocumentFail({ error, id }) {
  return {
    type: types.DELETE_CONTRACT_DOCUMENT_FAIL,
    error,
    id
  };
}

// ------- Delete Contract Attachemnt
export function deleteContractAttachment({ id, attachmentId }) {
  return {
    type: types.DELETE_CONTRACT_ATTACHMENT_REQUEST,
    id,
    attachmentId
  };
}

export function deleteContractAttachmentSuccess({ data, id }) {
  return {
    type: types.DELETE_CONTRACT_ATTACHMENT_SUCCESS,
    data,
    id
  };
}

export function deleteContractAttachmentFail({ error, id }) {
  return {
    type: types.DELETE_CONTRACT_ATTACHMENT_FAIL,
    error,
    id
  };
}

// ------- Submit quotet
export function submitQuote({ id }) {
  return {
    type: types.SUBMIT_QUOTE_REQUEST,
    id
  };
}

export function submitQuoteSuccess({ data, id }) {
  return {
    type: types.SUBMIT_QUOTE_SUCCESS,
    data,
    id
  };
}

export function submitQuoteFail({ error, id }) {
  return {
    type: types.SUBMIT_QUOTE_FAIL,
    error,
    id
  };
}

// ------- CryptologSign
export function cryptologSign({ id }) {
  return {
    type: types.CRYPTOLOG_SIGN_REQUEST,
    id
  };
}

export function cryptologSignSuccess({ data, id }) {
  return {
    type: types.CRYPTOLOG_SIGN_SUCCESS,
    data,
    id
  };
}

export function cryptologSignFail({ error, id }) {
  return {
    type: types.CRYPTOLOG_SIGN_FAIL,
    error,
    id
  };
}

// ------- CryptologCheck
export function cryptologCheck({ id }) {
  return {
    type: types.CRYPTOLOG_CHECK_REQUEST,
    id
  };
}

export function cryptologCheckSuccess({ data, id }) {
  return {
    type: types.CRYPTOLOG_CHECK_SUCCESS,
    data,
    id
  };
}

export function cryptologCheckFail({ error, id }) {
  return {
    type: types.CRYPTOLOG_CHECK_FAIL,
    error,
    id
  };
}

// ------- fetchNotes
export function fetchNotes({ id }) {
  return {
    type: types.FETCH_CONTRACT_NOTES_REQUEST,
    id
  };
}

export function fetchNotesSuccess({ data, id }) {
  return {
    type: types.FETCH_CONTRACT_NOTES_SUCCESS,
    data,
    id
  };
}

export function fetchNotesFail({ error, id }) {
  return {
    type: types.FETCH_CONTRACT_NOTES_FAIL,
    error,
    id
  };
}

// ------- fetchNote
export function fetchNote({ id }) {
  return {
    type: types.FETCH_CONTRACT_NOTE_REQUEST,
    id
  };
}

export function fetchNoteSuccess({ data, id }) {
  return {
    type: types.FETCH_CONTRACT_NOTE_SUCCESS,
    data,
    id
  };
}

export function fetchNoteFail({ error, id }) {
  return {
    type: types.FETCH_CONTRACT_NOTE_FAIL,
    error,
    id
  };
}

// ------- createNote
export function createNote({ id, message }) {
  return {
    type: types.CREATE_CONTRACT_NOTE_REQUEST,
    id,
    message
  };
}

export function createNoteSuccess({ noteId, id }) {
  return {
    type: types.CREATE_CONTRACT_NOTE_SUCCESS,
    noteId,
    id
  };
}

export function createNoteFail({ error, id }) {
  return {
    type: types.CREATE_CONTRACT_NOTE_FAIL,
    error,
    id
  };
}

// ------- download attachment
export function downloadAttachment({ token }) {
  return {
    type: types.DOWNLOAD_ATTACHMENT_REQUEST,
    token
  };
}
export function downloadAttachmentSuccess({ data, token }) {
  return {
    type: types.DOWNLOAD_ATTACHMENT_SUCCESS,
    data
  };
}
export function downloadAttachmentFail({ error, token }) {
  return {
    type: types.DOWNLOAD_ATTACHMENT_FAIL,
    error
  };
}

// ------- upload document request line
export function updateDocumentRequestLine({ query, files, contractNumber, quoteNumber }) {
  return {
    type: types.UPDATE_DOCUMENT_REQUEST_LINE_REQUEST,
    query,
    files,
    contractNumber,
    quoteNumber
  };
}
export function updateDocumentRequestLineSuccess({ data }) {
  return {
    type: types.UPDATE_DOCUMENT_REQUEST_LINE_SUCCESS,
    data
  };
}
export function updateDocumentRequestLineFail({ error }) {
  return {
    type: types.UPDATE_DOCUMENT_REQUEST_LINE_FAIL,
    error
  };
}
